export default {
  selectLanguage: {
    id: 'merchant_login_page_login_selected_label',
    defaultMessage: 'Selected Language',
  },
  languageOptionLabelFR: {
    id: 'language_select_option_label_fr',
    defaultMessage: 'French (France)',
  },
  languageOptionLabelAT: {
    id: 'language_select_option_label_at',
    defaultMessage: 'German (Austria)',
  },
  languageOptionLabelBE: {
    id: 'language_select_option_label_be',
    defaultMessage: 'French (Belgium)',
  },
  languageOptionLabelDE: {
    id: 'language_select_option_label_de',
    defaultMessage: 'German (Germany)',
  },
  languageOptionLabelES: {
    id: 'language_select_option_label_es',
    defaultMessage: 'Spanish (Spain)',
  },
  languageOptionLabelFI: {
    id: 'language_select_option_label_fi',
    defaultMessage: 'Finnish (Finland)',
  },
  languageOptionLabelGB: {
    id: 'language_select_option_label_gb',
    defaultMessage: 'English (United Kingdom)',
  },
  languageOptionLabelGR: {
    id: 'language_select_option_label_gr',
    defaultMessage: 'Greek (Greece)',
  },
  languageOptionLabelIE: {
    id: 'language_select_option_label_ie',
    defaultMessage: 'English (Ireland)',
  },
  languageOptionLabelIT: {
    id: 'language_select_option_label_it',
    defaultMessage: 'Italian (Italy)',
  },
  languageOptionLabelNL: {
    id: 'language_select_option_label_nl',
    defaultMessage: 'Dutch (Netherlands)',
  },
  languageOptionLabelPT: {
    id: 'language_select_option_label_pt',
    defaultMessage: 'Portuguese (Portugal)',
  },
  languageOptionLabelSE: {
    id: 'language_select_option_label_se',
    defaultMessage: 'Swedish (Sweden)',
  },
  languageOptionLabelSK: {
    id: 'language_select_option_label_sk',
    defaultMessage: 'Slovak (Slovakia)',
  },
  languageOptionLabelUS: {
    id: 'language_select_option_label_us',
    defaultMessage: 'English (United States)',
  },
  languageOptionLabelJP: {
    id: 'language_select_option_label_jp',
    defaultMessage: 'Japanese (Japan)',
  },
  languageOptionLabelAU: {
    id: 'language_select_option_label_au',
    defaultMessage: 'English (Australia)',
  },
  languageOptionLabelCN: {
    id: 'language_select_option_label_CN',
    defaultMessage: 'Chinese (Simplified)',
  },
}
